import { render, staticRenderFns } from "./UnitsEditor.yaml?vue&type=template&id=ac53d378&component"
import script from "./UnitsEditor.yaml?vue&type=script&lang=ts&component"
export * from "./UnitsEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports